// extracted by mini-css-extract-plugin
export var trigger = "dropdown-module--trigger--AGjQ9";
export var item = "dropdown-module--item--gC3Wm";
export var arrow = "dropdown-module--arrow--1MqkY";
export var content = "dropdown-module--content--8J9QD";